import { render, staticRenderFns } from "./approvalDialog.vue?vue&type=template&id=5b851b18&scoped=true"
import script from "./approvalDialog.vue?vue&type=script&lang=js"
export * from "./approvalDialog.vue?vue&type=script&lang=js"
import style0 from "./approvalDialog.vue?vue&type=style&index=0&id=5b851b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b851b18",
  null
  
)

export default component.exports